import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      allProductTypes: []
    }
  },
  computed: {
    ...mapGetters(['baseDomain', 'shopId', 'locale', 'apiKey']),
  },
  methods: {
    loadProductTypes () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?types=objects&apikey=' + this.apiKey)
        } catch(e) {}
        if (response) {
          this.allProductTypes = response.data
        }
        resolve(this.allProductTypes)
      })
    },
    productType (product) {
      if (!this.allProductTypes.length) {
        return ''
      }
      let subtype = product.subtype ? product.subtype : 0
      let displayedtype = product.displayedtype ? product.displayedtype : false
      let type = this.allProductTypes.find(type => type.type === parseInt(product.type) && type.subtype === parseInt(subtype) && (displayedtype === false || displayedtype === type.displayedtype))
      if (type) {
        return type.title
      } else {
        return ''
      }
    }
  }
}